import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Col, Container, Row, Badge } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Loader from '../../components/loaders/Loader'
import { getAnimal } from '../../actions/other/animalsActions'
import CardSemental from '../../components/cards/CardSemental'
import CardVaca from '../../components/cards/CardVaca'
import CardNovilla from '../../components/cards/CardNovilla'
import CardTernero from '../../components/cards/CardTernero'
import CardGeneral from '../../components/cards/CardGeneral'

export default function AnimalDetails() {
    const { id } = useParams()
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { animal, loading } = useSelector(state => state.animals)

    useEffect(() => {
        dispatch(getAnimal(id))
    }, [dispatch, id])

    if (loading || !animal) {
        return <Loader />
    }

    const renderCardByCategory = () => {
        switch (animal.category?.toLowerCase()) {
            case 'semental':
                return <CardSemental animal={animal} />
            case 'vaca':
                return <CardVaca animal={animal} />
            case 'novilla':
                return <CardNovilla animal={animal} />
            case 'ternero':
                return <CardTernero animal={animal} />
            default:
                return <CardGeneral animal={animal} />
        }
    }

    return (
        <Container className="py-5">
            <Row className="mb-4">
                <Col>
                    <h2>ID: {animal.identifier}</h2>
                </Col>
            </Row>
            <Card>
                <Card.Body>
                    {renderCardByCategory()}
                </Card.Body>
            </Card>
        </Container>
    )
}
